<template>
  <div
    :class="showFold ? '' : 'inactive'"
    class="leftBox"
    :style="{ background: swiechColor }"
  >
    <div @click="foldClick" class="fold-div">
      <i :class="showFold ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"> </i>
      <span>{{ showFold ? "收起" : "展开" }}</span>
    </div>
    <LeftItem01
      v-if="showFold"
      class="leftItem01Box"
      :leftObj="leftObj.leftItem01Obj"
      style="height: 66%; margin-bottom: 2%"
    />
    <LeftItem02
      v-if="showFold"
      class="leftItem02Box"
      :leftObj="leftObj.leftItem02Obj"
      style="height: 32%"
    />
  </div>
</template>

<script>
import LeftItem01 from "./leftItem01.vue";
import LeftItem02 from "./leftItem02.vue";
export default {
  props: {
    swiechColor: {
      typeof: String,
    },
    leftObj: {
      typeof: Object,
    },
  },
  components: {
    LeftItem01,
    LeftItem02,
  },
  data() {
    return {
      showFold: true,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.$bus.$on("foldClick-left", (show) => {
      this.showFold = show;
    });
  },
  methods: {
    foldClick() {
      this.showFold = !this.showFold;
    },
  },
};
</script>

<style lang="scss" scoped>
.inactive {
  width: 100px !important;
  overflow: hidden;

  .fold-div {
    right: 40px !important;
  }
}
.leftBox {
  width: 24%;
  height: 88%;
  color: #fff;
  position: relative;

  .fold-div {
    position: absolute;
    right: 16px;
    top: 16px;
    font-size: 16px;
    cursor: pointer;
  }
  .leftItem01Box,
  .leftItem02Box {
    padding-top: 0.5vh;
    background: url("../../../assets/dataScreen/leftBorder.png") no-repeat; // no-repeat top center / cover
    background-size: 100% 100%;
    background-color: rgba(9, 21, 42, 0.8);
    border-radius: 4px;
  }
}
</style>
